import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { setBlockProperties } from '../../../../store/actions/blocks'
import { uploadToBlock } from '../../../../store/actions/upload'

export const ColorBlockOptionsContainer = compose(
  connect(
    (state, { block }) => ({
      color: block.style && block.style.background
    }),
    (dispatch, { block }) => ({
      setColor: color =>
        dispatch(setBlockProperties(block, { 'style/background': color })),
      upload: event => {
        dispatch(uploadToBlock(event.target.files, block))
        event.target.value = ''
      }
    })
  ),
  withTranslation()
)

export default ColorBlockOptionsContainer
